import {
  CREATE_QUESTION,
  CREATE_QUESTION_SUCCESS,
  CREATE_QUESTION_FAILURE,
} from 'store/createQuestion/createQuestionAction';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const postQuestionReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_QUESTION:
      return { ...state, loading: true };
    case CREATE_QUESTION_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case CREATE_QUESTION_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default postQuestionReducer;
